export const isAdminDotAirDotInc = () => {
  /**
   * Uncomment for localhost testing
   */
  // return typeof window !== 'undefined' && window.location.hostname === 'localhost';

  return typeof window !== 'undefined' && window.location.hostname === 'admin.air.inc';
};
